export class BankTransferPaymentConfig {
    public allowBankTransferPayments?: boolean;
    public accountNumberToBankTransfer?: string;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): BankTransferPaymentConfig {
        const bankTransferPaymentConfig: BankTransferPaymentConfig = new BankTransferPaymentConfig();

        bankTransferPaymentConfig.allowBankTransferPayments = this.allowBankTransferPayments;
        bankTransferPaymentConfig.accountNumberToBankTransfer = this.accountNumberToBankTransfer;

        return bankTransferPaymentConfig;
    }
}
